import React from 'react'
import { Modal } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import { BitacoraComponent } from 'recupero-bitacora'

const ModalBitacora = ({ show, handleClose, rutcia, idCaso, user }) => {
  return (
    <Modal
      show={show}
      size='xl'
      aria-labelledby='contained-modal-title-vcenter'
      onHide={handleClose}
    >
      <Modal.Body className='show-grid'>
        <BitacoraComponent rutcia={rutcia} idCaso={idCaso} user={user} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalBitacora
